/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { Mutation, withApollo } from 'react-apollo'
import format from 'date-fns/format'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import PlacesAutocomplete, {
  getLatLng,
  geocodeByAddress,
} from 'react-places-autocomplete'
import omit from 'lodash/omit'
import get from 'lodash/get'
import pick from 'lodash/pick'

import {
  FIND_EVENT_QUERY,
  EVENTS_QUERY,
  CREATE_EVENT_MUTATION,
  UPDATE_EVENT_MUTATION,
} from 'graphql/queries'
import { EVENT_TYPES, TIMEZONES } from 'config/constants'

import { Container, Header, Button, Form } from 'semantic-ui-react'
import { getImageDimensions, isValidImageSize } from 'utils/helpers'
window.format = format

class NewEvent extends Component {
  state = {
    type: EVENT_TYPES[0],
    title: '',
    description: '',
    address: '',
    location: '',
    startDate: 0, // initialized to 0 from undefined, not sure why it was set to undefined before
    startTime: 0,
    endTime: 0,
    timezone: TIMEZONES[0],
    imgUrl: '',
    lat: 0,
    lng: 0,
    price: '',
    webinarUrl: '',
    previewImageSrc: '',
    file: null,
  }

  componentDidMount() {
    const { client, match } = this.props
    if (match.params.eventId) {
      client
        .query({
          query: FIND_EVENT_QUERY,
          variables: { id: match.params.eventId },
        })
        .then(response => {
          const initialState = pick(response.data.eventData, [
            'title',
            'description',
            'location',
            'webinarUrl',
            'imgUrl',
            'address',
            'lat',
            'lng',
            'eventStartTime',
            'eventEndTime',
            'price',
          ])
          const {
            title,
            description,
            location,
            webinarUrl,
            imgUrl,
            address,
            lat,
            lng,
            eventEndTime,
            eventStartTime,
            price,
          } = initialState

          this.setState({
            title,
            description,
            location,
            webinarUrl,
            previewImageSrc: imgUrl,
            address,
            lat,
            lng,
            startDate: format(eventStartTime, 'YYYY-MM-DD'),
            startTime: format(eventStartTime, 'hh:mm'),
            endTime: format(eventEndTime, 'hh:mm'),
            price,
          })
        })
    }
  }

  handleImageFileChange = async event => {
    const file = event.target.files[0]
    const dimensions = await getImageDimensions(file)
    if (isValidImageSize(dimensions)) {
      const reader = new FileReader()

      reader.addEventListener('load', () => {
        this.setState({ previewImageSrc: reader.result })
      })

      if (file) {
        reader.readAsDataURL(file)
        this.setState({ file })
      }
    } else {
      this.setState({ previewImageSrc: '', file: null })
    }
  }

  removeImage = () =>
    this.setState({
      imgUrl: '',
      previewImageSrc: '',
      file: null,
    })

  formatVariables = id => {
    const input = omit(this.state, [
      'previewImageSrc',
      'file',
      'type',
      'imgUrl',
    ])

    let [year, month, day] = input.startDate.split('-').map(Number)
    month--

    const startTime = new Date(year, month, day)
    const [startTimeHours, startTimeMinutes] = input.startTime
      .split(':')
      .map(Number)
    startTime.setHours(startTimeHours)
    startTime.setMinutes(startTimeMinutes)

    const endTime = new Date(year, month, day)
    const [endTimeHours, endTimeMinutes] = input.endTime.split(':').map(Number)
    endTime.setHours(endTimeHours)
    endTime.setMinutes(endTimeMinutes)

    input.startTime = +startTime
    input.endTime = +endTime
    delete input.startDate
    delete input.eventType

    input.tzOffset = input.timezone.value * 60 * 60 * 1000
    delete input.timezone

    const variables = id ? { id, input } : { input }

    if (this.state.file) {
      variables.file = this.state.file
    }

    return variables
  }

  render() {
    const {
      title,
      description,
      webinarUrl,
      price,
      address,
      location,
      previewImageSrc,
      imgUrl,
      startTime,
      endTime,
      startDate,
      timezone,
    } = this.state

    const hasImage = imgUrl || previewImageSrc
    const id = get(this.props, 'match.params.eventId', '')

    return (
      <Container style={{ marginBottom: 64 }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 16,
          }}
        >
          <Header as="h1" content="New Event" />
          <div style={{ display: 'flex' }}>
            <Mutation
              mutation={id ? UPDATE_EVENT_MUTATION : CREATE_EVENT_MUTATION}
              refetchQueries={[
                { query: EVENTS_QUERY, variables: { limit: 1000, offset: 0 } },
              ]}
            >
              {saveEvent => {
                return (
                  <Button
                    primary
                    onClick={() => {
                      const variables = this.formatVariables(id)
                      saveEvent({ variables }).then(() =>
                        this.props.history.push('/events'),
                      )
                    }}
                  >
                    Save
                  </Button>
                )
              }}
            </Mutation>
            <Link to="/events">
              <Button>Back</Button>
            </Link>
          </div>
        </div>

        <Form>
          {/* <Select
            options={EVENT_TYPES}
            value={eventType}
            getOptionLabel={option => option.label}
            onChange={type => this.setState({ eventType: type })}
          /> */}

          <Form.Input
            label="Event Title"
            id="title"
            value={title}
            onChange={event => this.setState({ title: event.target.value })}
          />

          <Form.TextArea
            label="Description"
            id="description"
            value={description}
            onChange={event =>
              this.setState({ description: event.target.value })
            }
          />
          <Form.Input
            label="Event Location"
            id="location"
            value={location}
            onChange={event => this.setState({ location: event.target.value })}
          />
          <Form.Input
            label="Webinar URL"
            id="webinarUrl"
            type="url"
            value={webinarUrl}
            onChange={event =>
              this.setState({ webinarUrl: event.target.value })
            }
          />

          <Form.Group>
            <div>
              <Form.Input
                label="Main Image (must be at least 670x370)"
                id="imgUrl"
                type="file"
                accept=".jpg,.png,.jpeg,.gif,.svg"
                value={imgUrl}
                onChange={this.handleImageFileChange}
              />
              {hasImage && (
                <Button
                  style={{ marginTop: 12 }}
                  color="red"
                  onClick={this.removeImage}
                >
                  Remove Image
                </Button>
              )}
            </div>
            {hasImage && (
              <div
                style={{
                  backgroundImage: `url(${imgUrl || previewImageSrc})`,
                  backgroundSize: 'contain',
                  height: 370,
                  width: 670,
                }}
              />
            )}
          </Form.Group>

          <div style={{ display: 'flex', marginBottom: 12 }}>
            <div style={{ flex: 1, marginRight: 12 }}>
              <Form.Input
                label="Start Date"
                type="date"
                value={startDate}
                onChange={event =>
                  this.setState({ startDate: event.target.value })
                }
              />
            </div>
            <div style={{ flex: 1, marginRight: 12 }}>
              <Form.Input
                label="Start Time"
                type="time"
                value={startTime}
                onChange={event =>
                  this.setState({ startTime: event.target.value })
                }
              />
            </div>
            <div style={{ flex: 1, marginRight: 12 }}>
              <Form.Input
                label="End Time"
                type="time"
                value={endTime}
                onChange={event =>
                  this.setState({ endTime: event.target.value })
                }
              />
            </div>
            <div className="field" style={{ flex: 1 }}>
              <label htmlFor="timezone">Timezone</label>
              <Select
                id="timezone"
                options={TIMEZONES}
                value={timezone}
                onChange={value => this.setState({ timezone: value })}
              />
            </div>
          </div>

          <PlacesAutocomplete
            value={address}
            onError={console.error.bind(window)}
            onChange={addr => this.setState({ address: addr })}
            onSelect={addr => {
              geocodeByAddress(addr)
                .then(results => getLatLng(results[0]))
                .then(({ lat, lng }) =>
                  this.setState({ lat, lng, address: addr }),
                )
                .catch(error => console.error('error geocoding address', error))
            }}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }) => {
              return (
                <div>
                  <Form.Input
                    label="Event Address"
                    id="address"
                    {...getInputProps()}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      zIndex: 1000,
                      width: '100%',
                      fontSize: 18,
                      border: suggestions.length ? '1px solid grey' : 'none',
                    }}
                  >
                    {loading && <div>Loading...</div>}
                    {suggestions.map(suggestion => {
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? {
                            backgroundColor: '#fafafa',
                            cursor: 'pointer',
                            padding: 4,
                          }
                        : {
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                            padding: 4,
                          }
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            style,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            }}
          </PlacesAutocomplete>
          <Form.Input
            label="Event Price"
            id="price"
            value={price}
            onChange={event => this.setState({ price: event.target.value })}
          />
        </Form>
      </Container>
    )
  }
}

export default withApollo(NewEvent)
